import { copyToClipboard } from './clipboard';
import { useToastStore } from '../store/toastStore';

export async function copyRegistrationCode(code: string): Promise<void> {
  const ok = await copyToClipboard(code);
  useToastStore.getState().addToast(
    ok
      ? { type: 'success', title: 'Copied', message: 'Registration code copied.' }
      // The code is drawn one character to a box, so it can't be selected as one.
      : { type: 'error', title: 'Copy failed', message: 'Type the code in by hand instead.' },
  );
}
